import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  Spinner, 
  Alert, 
  Row,
  Col, 
  Button,
  CardHeader,
  Input,
} from "reactstrap";
import { getMyGroups } from "../service/authApi";
import { MyGroupDto } from "../types/authTypes";
import {  useNavigate } from "react-router-dom";
import CommunityDiscussion from "../../../module/Group Module/Components/CommunityDiscussion";
import "./MyGroup.css";
// eslint-disable-next-line
interface Props {
    groupId: string;
    isJoined: boolean;
    coordinatorName: string;
    totalMembers: number;
}

function MyGroup() {

const navigate = useNavigate();
    const [groups, setGroups] = useState<MyGroupDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
const [selectedGroup, setSelectedGroup] = useState<MyGroupDto | null>(null);
const [selectedGroupId, setSelectedGroupId] = useState<string>("");   

    const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
  try {
    setLoading(true);

    const response = await getMyGroups();

    setGroups(response.groups);
  } catch (err) {
    console.error(err);
    setError("Failed to load joined groups.");
  } finally {
    setLoading(false);
  }
};


    
  return (
     <Container className="mt-4">
      <Card className="shadow-sm">
        <CardBody>
          <h3 className="mb-4">My Groups</h3>

          <div className="mb-4">
  <label style={{ fontWeight: 600, marginBottom: "8px" }}>
    Select Group
  </label>

 <div className="group-filter">

  <Input
className="group-select"
    type="select"
    value={selectedGroupId}
    onChange={(e) => {
      const id = e.target.value;
      setSelectedGroupId(id);

      if (!id) {
        setSelectedGroup(null);
        return;
      }

      const group = groups.find((g: any) => g.groupId === id);
      if (group) {
        setSelectedGroup(group);
      }
    }}
  >
    <option value="">-- Select Group --</option>

{groups
  .filter((group: any) =>
    selectedGroupId ? group.groupId === selectedGroupId : true
  )
  .map((group: any) => (
    <option key={group.groupId} value={group.groupId}>
      {group.groupName}
    </option>
))}
  </Input>
  <Button
className="clear-btn"
    color="secondary"
    onClick={() => {
      setSelectedGroupId("");
      setSelectedGroup(null);
    }}
  >
    Clear
  </Button>
  </div>
</div>

          {loading && (
            <div className="text-center py-5">
              <Spinner color="primary" />
            </div>
          )}

          {error && <Alert color="danger">{error}</Alert>}

          {!loading && groups.length === 0 && (
            <Alert color="info">No joined groups found.</Alert>
          )}

       
        </CardBody>
      </Card>

      {selectedGroup && (
    <Card
        className="mt-4 shadow"
        style={{
            borderRadius: "20px",
            overflow: "hidden",
            border: "none",
        }}
    >
       <CardHeader className="discussion-header">
           <h5 className="discussion-title mb-0">
                {selectedGroup.groupName} - Community Discussion
            </h5>

          <div className="header-buttons">
    <Button
        className="details-btn"
        size="sm"
        color="light"
        onClick={() => navigate(`/groups/${selectedGroup.slug}`)}
    >
        View Details
    </Button>

    <Button
        size="sm"
        color="light"
        onClick={() => setSelectedGroup(null)}
    >
        Close
    </Button>
</div>
        </CardHeader>

        <CardBody>
          <CommunityDiscussion
    groupId={selectedGroup.groupId}
    isJoined={true}
    coordinatorName=""
    totalMembers={0}
/>
        </CardBody>
    </Card>
)}
    </Container>
  )
}

export default MyGroup